export default __webpack_public_path__ + "static/media/ies_NickAlbert.1912b3fb.png";